import React from "react";
import { Helmet } from "react-helmet-async";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Helmet>
        <title>Refund Policy – OjoVest</title>
        <link rel="canonical" href="https://www.ojovest.com/refund" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-4 py-12">
        <h1 className="text-3xl font-semibold tracking-tight">Refund Policy</h1>
        <p className="mt-3 text-sm text-slate-600">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <div className="mt-8 space-y-5 text-sm leading-7 text-slate-700">
          <p>
            If OjoVest charges any service fees, refunds (if applicable) are evaluated case-by-case
            based on the scope of work already delivered.
          </p>
          <p>
            Banking/issuer charges, processing fees, and third-party charges are non-refundable.
          </p>
          <p>
            To request a refund, contact support@ojovest.com with your registered email and details.
          </p>
        </div>
      </div>
    </div>
  );
}
